import React, { Component } from "react";

import Video from "../../Components/Video";

class WatKunnenWijDoen extends Component {
  render() {
    return (
      <div className="wat-kunnen-wij-doen">
        <Video video={"https://www.youtube.com/embed/46L4XEeCduo"} />
      </div>
    );
  }
}

export default WatKunnenWijDoen;